// Build-time configuration. CRA inlines REACT_APP_* variables when the bundle
// is built; per-environment values live in .env.development /
// .env.production, and the deploy workflow can override them for staging.
// Fallbacks point at production so a missing variable never breaks the site.
const config = {
  counterApiUrl:
    process.env.REACT_APP_COUNTER_API_URL ||
    "https://ca510kc1ig.execute-api.eu-north-1.amazonaws.com/counter",
  signedUrlApi:
    process.env.REACT_APP_SIGNED_URL_API ||
    "https://5w6fa6obpl.execute-api.eu-north-1.amazonaws.com/prod/GenerateSignedURL",
  // When set, images load directly from CloudFront
  // (`${imageBaseUrl}/images/N.jpg`) instead of via presigned URLs.
  imageBaseUrl:
    process.env.REACT_APP_IMAGE_BASE_URL || "https://img.artefactly.com",
  // Collections API (DynamoDB-backed, free tier). Public GET; admin writes are
  // gated by a Cognito JWT authorizer.
  collectionsApiUrl:
    process.env.REACT_APP_COLLECTIONS_API_URL ||
    "https://ca510kc1ig.execute-api.eu-north-1.amazonaws.com/collections",
  // Exhibitions API (same HTTP API): which collection hangs in which 3D museum.
  exhibitionsApiUrl:
    process.env.REACT_APP_EXHIBITIONS_API_URL ||
    "https://ca510kc1ig.execute-api.eu-north-1.amazonaws.com/exhibitions",
  // Quotes API (same HTTP API): the loading-screen corpus. Public GET; admin
  // writes are gated by the Cognito JWT authorizer.
  quotesApiUrl:
    process.env.REACT_APP_QUOTES_API_URL ||
    "https://ca510kc1ig.execute-api.eu-north-1.amazonaws.com/quotes",
  adminQuotesApiUrl:
    process.env.REACT_APP_ADMIN_QUOTES_API_URL ||
    "https://ca510kc1ig.execute-api.eu-north-1.amazonaws.com/admin/quotes",
  // Admin Cognito user pool (public identifiers, not secrets). Powers /admin.
  adminUserPoolId: process.env.REACT_APP_ADMIN_USER_POOL_ID || "eu-north-1_p2lknkP27",
  adminClientId: process.env.REACT_APP_ADMIN_CLIENT_ID || "30b7aue5pcv7andtp1p1hvh7a0",
};

export default config;
